import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Error from "../../../components/Error";
import Pagination from "../../program/components/Pagination";
import { useCardsPage } from "../cardsPageContext";
import { PrivateClassCard } from "./Card/PrivateClassCard";

const useStyles = makeStyles(() => ({
  card: {
    borderRadius: 16,
    boxShadow: "0 0 4px 0 #c2c9d6",
    padding: 24,
    backgroundColor: "#fff",
    marginBottom: 16,
  },
  subjectName: {
    fontWeight: 500,
    fontSize: "1.125rem",
    color: "#231f20",
    margin: 0,
  },
}));

const PrivateClassCardsList: FC = () => {
  const classes = useStyles();
  const {
    paginationConfig,
    setPaginationConfig,
    cards = [],
    totalCount = 0,
  } = useCardsPage();

  return (
    <>
      {!cards.length ? (
        <Error icon={"search"} text={"You have no results for now."} />
      ) : (
        <>
          {cards.map((card) => (
            <PrivateClassCard key={card.id} privateClass={card} />
          ))}
          <Pagination
            totalCount={totalCount}
            config={paginationConfig}
            onChange={setPaginationConfig}
            label="classes"
          />
        </>
      )}
    </>
  );
};

export default React.memo(PrivateClassCardsList);
